import Inputmask from 'inputmask';

let cancelToken;

window.mobileCheck = function () {
    let check = false;
    (function (a) {
        // noinspection RegExpSingleCharAlternation,RegExpRedundantEscape
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};

// region Radio and Checkbox Fix
$('.radio-label').keypress(function (e) {
    if (e.keyCode === 0 || e.keyCode === 32) {
        $(this).find('input').prop('checked', true);
    }
});
$(document).on('click', '.radio-wrapper', function (e) {
    let name = $(this).find('input').attr('name')

    $('input[name="' + name + '"]').each(function () {
        $(this).removeAttr('checked');
    });

    $(this).find('input').prop('checked', true);
});

$('.checkbox-label').keypress(function (e) {
    if (e.keyCode === 0 || e.keyCode === 32) {
        let $ele = $(this).find('input');
        $ele.prop('checked', !$ele.is(':checked'));
    }
});
// endregion

// region Modal trap keyboard focus function
window.trapKeyboardFocus = function(selector_id) {
    const modal = document.querySelector(selector_id); // select the modal by it's id
    if (!modal) {
        console.error('Modal does not exist: ' + selector_id);
        return;
    }

    // add all the elements inside modal which you want to make focusable
    const focusableElements =
        '[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

    const firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
    const focusableContent = modal.querySelectorAll(focusableElements);
    const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

    document.addEventListener('keydown', function (e) {
        let isTabPressed = e.key === 'Tab';

        if (!isTabPressed) {
            return;
        }

        if (e.shiftKey) { // if shift key pressed for shift + tab combination
            if (document.activeElement === firstFocusableElement) {
                console.log('shift');
                lastFocusableElement.focus(); // add focus for the last focusable element
                e.preventDefault();
            }
        } else { // if tab key is pressed
            if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
                console.log('tab');
                firstFocusableElement.focus(); // add focus for the first focusable element
                e.preventDefault();
            }
        }
    });
}

// endregion

//region Side Menu Toggle (hamburger on mobile)
$(document).on('click', '.js-toggle-side-menu', function (event) {
    event.preventDefault();
    let $sideMenu = $('.js-side-menu');
    $sideMenu.toggleClass('open');

    if ($sideMenu.hasClass('open')) {
        $('#js-scrolled-focus-mobile').attr('aria-expanded', 'true');

        $sideMenu.attr('aria-hidden', 'false');
        $sideMenu.find('.side-menu-header').attr('aria-hidden', 'false');
        $sideMenu.find('a').attr('tabindex', '0').attr('aria-hidden', 'false');
        // set modal content exposed to accessibility tree
        $('.js-close-menu').attr('tabindex', '0');
        $('.js-menu-item').attr('tabindex', '0');
        trapKeyboardFocus('#js-side-modal');

    } else {
        $('#js-scrolled-focus-mobile').attr('aria-expanded', 'false');

        $sideMenu.attr('aria-hidden', 'true');
        $sideMenu.find('.side-menu-header').attr('aria-hidden', 'true');
        $sideMenu.find('a').attr('tabindex', '-1').attr('aria-hidden', 'true');
        $('.js-close-menu').attr('tabindex', '-1');
        $('.js-menu-item').attr('tabindex', '-1');
    }
});
// endregion

// region Modal Window Panel Collapse
$(document).on('hide.bs.collapse', '.collapse', function () {
    $('.accordion-button-icon').removeClass('minus').addClass('plus');
}).on('show.bs.collapse', function () {
    $('.accordion-button-icon').removeClass('plus').addClass('minus');
});

$(document).on('show.bs.modal', '.modal', function () {
    $('.modal .modal-body').css({'overflow-y': 'auto', 'max-height': $(window).height() * 0.7});
});
// endregion

// region Range Slider
if ($('.js-input-slider').length > 0) {
    $(document).on('input', '.js-input-slider', function () {
        let self = $(this);
        let max = parseInt(self.attr('max'), 10);
        let totalValue = 0;
        let othersValue = 0;

        $('.js-input-slider').each(function () {
            totalValue += parseInt($(this).val(), 10);
            if ($(this).attr('name') !== self.attr('name')) {
                othersValue += parseInt($(this).val(), 10);
            }
        });

        let currentValue = parseInt(self.val(), 10);
        if (totalValue > max) {
            currentValue = max - othersValue;
            self.val(currentValue)
        }

        let $output = $(this).closest('.slider').find('output');

        $output.val('£' + currentValue)
    });
}
// endregion

$(function () {
    // region Scroll to Errors
    let $elementError = $('.form-group.has-error:first');
    if ($elementError.length > 0) {
        // scroll to error
        $('html, body').animate({
            scrollTop: $elementError.offset().top
        }, 100);
    }
    $elementError = $('.alert.alert-danger:first');
    if ($elementError.length > 0) {
        // scroll to error
        $('html, body').animate({
            scrollTop: $elementError.offset().top
        }, 100);
    }
    // endregion

    // region Scroll to message if on mobile
    if (window.mobileCheck()) {
        let $elementMessage = $('.alert.alert-danger');
        if ($elementMessage.length > 0) {
            $('html, body').animate({
                scrollTop: $elementMessage.offset().top
            }, 100);
        }
    }
    // endregion

    // region Date Picker
    let $datePickers = $('.date_picker');
    if ($datePickers.length > 0) {
        $datePickers.datepicker({
            format: "dd-mm-yyyy",
            todayHighlight: true,
            orientation: "bottom auto",
            autoclose: true,
        }).on('changeDate', function (selected) {
            $(this).trigger('focusout');
        });
    }
    // endregion

    Inputmask().mask($("input[data-inputmask]"));
});

// region Message Scroll
let $chatArea = $('.js-messages');

$(document).ready(function () {
    $chatArea.scrollTop($chatArea.prop('scrollHeight'));
});
// endregion

// region Account JS
$('.container.raf').on('click', '.js-social-whatsapp', function (event) {
    event.preventDefault();

    $('.js-social-form').attr('data-href', ($(this).attr('href'))).removeClass('d-none');
}).on('submit', '.js-social-form', function (event) {
    event.preventDefault();

    let url = $(this).attr('data-href');
    url = url.replace('[FRIENDS NUMBER]', $(this).find('input').val());

    window.open(url, '_blank');
});
// endregion

// region Accordion Fix
// $(document).on('click', '.simple-accordion .collapse-label', function (event) {
//     event.stopPropagation();
//     let $this = $(this);
//     let href;
//
//     let parent = $this.data('parent');
//     let actives = parent && $(parent).find('.collapse.in');
//
//     if (actives && actives.length) {
//         actives.collapse('hide');
//     }
//
//     let target = $this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, ''); //strip for ie7
//
//     if ($(target).length > 0) {
//         $(target).collapse('toggle');
//     }
// });

$(document).ready(function () {
    if (window.location.hash !== '' && $(window.location.hash).length > 0) {
        $(window.location.hash).find('.collapse-label').trigger('click');

        let acc = document.getElementsByClassName("js-collapse-label");
        let i;
        for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function() {
                /* Toggle between adding and removing the "active" class,
                to highlight the button that controls the panel */
                this.classList.toggle("active");
                /* Toggle between hiding and showing the active panel */
                let panel = this.nextElementSibling;
                if (panel.style.display === "block") {
                    panel.style.display = "none";
                } else {
                    panel.style.display = "block";
                }
            });
        }
    }
});
// endregion

// region Tabs
$(document).on('click', '.tabs > li', function () {
    $('.tabs > li > a').removeClass('active');
    $(this).find('a').addClass('active');
});
// endregion

// region Claim Form Gift Select
$(document).on('click', '.js-address-fields .radio-wrapper', function (e) {
    // region Address
    let $addressFields = $('.js-address-fields');

    let addressCheck = JSON.parse($addressFields.attr('data-check'));
    let requireAddress = addressCheck[$(this).find('input').val()] === '1';

    $addressFields.find('input.form-control.js-required')
        .attr('aria-required', requireAddress)
        .attr('required', requireAddress);
    $('input[name="ra"]').val(requireAddress ? 1 : 0);

    requireAddress ? $addressFields.removeClass('d-none') : $addressFields.addClass('d-none');
    // endregion

    // region Bank Fields
    let $bankFields = $('.js-bank-fields');

    let bankCheck = JSON.parse($bankFields.attr('data-check'));
    let requireBank = bankCheck[$(this).find('input').val()] === '1';

    $bankFields.find('input.form-control.js-required')
        .attr('aria-required', requireBank)
        .attr('required', requireBank);
    $('input[name="ba"]').val(requireBank ? 1 : 0);

    requireBank ? $bankFields.removeClass('d-none') : $bankFields.addClass('d-none');
    // endregion
});
// endregion

// region Address Select
if ($('.js-get-address-list').length > 0) {
    $(document).on('click', '.js-get-address-list', function (event) {
        event.preventDefault();

        let addressType = $(this).attr('data-type');

        let postcode = $('[name="address[' + addressType + '][postcode]"]').val();

        if (postcode == undefined) {
            postcode = $('[name="postcode"]').val();
        }

        if (postcode === '') {
            return;
        }

        let $addressListField = $('#address_list_' + addressType);

        this.disabled = true;

        $.ajax({
            method: 'GET',
            dataType: 'json',
            data: {postcode: postcode},
            url: $(this).attr('data-url'),
            success: function (response) {
                let option = $('<option></option>')
                    .val('')
                    .attr('data-all', '')
                    .html('Please Select');

                $addressListField.find('option').remove();
                $addressListField.append(option);
                $.each(response, function () {
                    let display = this.address_1
                        + (this.address_2 !== '' && this.address_2 !== null ? ', ' + this.address_2 : '')
                        + ', ' + this.city_town;

                    let option = $('<option></option>')
                        .val(this.id)
                        .attr('data-all', JSON.stringify(this))
                        .html(display);

                    $addressListField.append(option);
                    $addressListField.closest('.js-address-list').fadeIn();
                });

                $addressListField.prop('disabled', false);
            },
            complete: () => {
                this.disabled = false;
            },
        });
    });

    $(document).on('change', '.js-address-select', function () {
        if ($(this).find('option:selected').attr('data-all') !== '') {
            let address = JSON.parse($(this).find('option:selected').attr('data-all'));

            let addressType = $(this).attr('data-type');

            // Check field with addressType exists to populate with address values
            if($('[name="address[' + addressType + '][address_1]').length) {
                $('[name="address[' + addressType + '][address_1]"]').val(address.address_1);
                $('[name="address[' + addressType + '][address_2]"]').val(address.address_2);
                $('[name="address[' + addressType + '][city_town]"]').val(address.city_town);
                $('[name="address[' + addressType + '][county]"]').val(address.county);
                $('[name="address[' + addressType + '][country]"]').val(address.country);
            } else {
                $('[name="address_1"]').val(address.address_1);
                $('[name="address_2"]').val(address.address_2);
                $('[name="city_town"]').val(address.city_town);
                $('[name="county"]').val(address.county);
                $('[name="country]"]').val(address.country);
            }
        }
    });
}
// endregion

// region Accessibility
function validateEmail(email) {
    // noinspection RegExpRedundantEscape
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function validateFormField() {
    let $this = $(this);
    let value = $this.val().trim();
    let id = $this.attr('id');
    let isRequired = $this[0].required;
    let $confirmation = $('#' + id.replace('_confirmation', ''));
    let $formGroup = $this.closest('.form-group');
    let $errorMessage = $formGroup.find('div[aria-live] p');

    let errorMessage = '';
    let isInvalid = false;

    if (isRequired && value === '') {
        isInvalid = true;
        errorMessage = $('.js-accessible').attr('data-required');
    } else if ($this.attr('type') === 'email' && !validateEmail(value)) {
        isInvalid = true;
        errorMessage = $('.js-accessible').attr('data-email');
    } else if (id.indexOf("_confirmation") >= 0 && $confirmation.length > 0 && $confirmation.val().trim() !== value) {
        isInvalid = true;
        errorMessage = $('.js-accessible').attr('data-confirm');
    } else if ($this[0].hasAttribute('data-inputmask') && !Inputmask().mask('#' + id).isComplete()) {
        isInvalid = true;
        errorMessage = $('.js-accessible').attr('data-inputmask');
    }

    $this.attr('aria-invalid', isInvalid);

    if (isInvalid) {
        $formGroup.removeClass('has-success').addClass('has-error');
        $formGroup.find('.error-msg').html('');
    } else {
        $formGroup.removeClass('has-error').addClass('has-success');
    }

    $errorMessage.text(errorMessage);
}

$(document).on('focusout', 'form:not(.no-validate) input:not([aria-disable="true"])', validateFormField);
$(document).on('focusout', 'form:not(.no-validate) select:not([aria-disable="true"])', validateFormField);
// endregion

// region Accessibility BackToTop scroll to top of the page with focus
$(document).on('click', '#js-scroll-up', function (e) {
    e.preventDefault();
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    setTimeout(function () {
        if (screen.width >= 768) {
            document.getElementById("js-scrolled-focus-desktop").focus();
        } else {
            //  $('.js-accessible-hamburger').find('a').focus();
            document.getElementById("js-scrolled-focus-mobile").focus();
        }
    }, 1)

});
// endregion

$(document).on('click', 'form .btn[type="submit"]', function (event) {
    if (window.mobileCheck()) {
        let invalid = $('form input:invalid, form select:invalid');

        if (invalid.length > 0) {
            event.preventDefault();
            event.stopPropagation();

            $('html, body').animate({
                scrollTop: $(invalid[0]).offset().top - 100
            }, 100);

            invalid[0].reportValidity();

            return false;
        }
    }
});

// region Slick Sliders
$(document).ready(function () {
    let $infoCarousel = $('.js-info-carousel');
    if ($infoCarousel.length) {
        const $paginationArrows = $(".slider-arrow")
            , $prevArrow = $paginationArrows.siblings(".icon-arrow-left")
            , $nextArrow = $paginationArrows.siblings(".icon-arrow-right");

        $infoCarousel.slick({
            autoplay: !0,
            autoplaySpeed: 5e3,
            accessibility: !1,
            arrows: !0,
            speed: 0,
            dots: !1,
            infinite: !0,
            focusOnSelect: !0,
            appendArrows: $paginationArrows,
            prevArrow: $prevArrow,
            nextArrow: $nextArrow,
            slidesToShow: 3,
            slidesToScroll: 3,
            cssEase: "linear",
            responsive: [
                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    let $carousel = $('.js-carousel');
    if ($carousel.length) {
        $carousel.slick({
            autoplay: !0,
            infinite: !1,
            speed: 3000,
            slidesToShow: 1,
            slidesToScroll: 1,
            focusOnSelect: !0,
            accessibility: !1,
            dots: !0,
            centerMode: !0,
        });
    }
});
// endregion

// region Nav Search
function nav_search($input, $form, $results) {
    let searchTerm = $input.val().trim();

    if (typeof cancelToken !== typeof undefined) {
        cancelToken.cancel("Operation canceled due to new request.");
    }

    cancelToken = axios.CancelToken.source();

    if (searchTerm === '') {
        $results.removeClass('active');
        $results.find('.js-search-result-list').html('');

        return;
    }

    axios({
        method: 'post',
        url: $form.attr('action'),
        data: {search: searchTerm},
        responseType: 'json',
        cancelToken: cancelToken.token,
    })
        .then((response) => {
            if (response.data.success) {
                $results.addClass('active');

                if (response.data.results.length === 0) {
                    $results.find('.js-search-result-list').html(`<li>${response.data.no_result}</li>`)
                } else {
                    let data = response.data;
                    let results = data.results;
                    let html = '';

                    Object.keys(results).forEach(function (key, index) {

                        html += `<div class="row">
                                    <div class="col-xs-12">
                                        <h5 class="text-left"><strong>${results[index].header}</strong></h5>
                                    </div>
                                 </div>`;

                        Object.keys(results[index].data).forEach(function (k, i) {
                            let element = results[index].data[i];
                            switch (results[index].id) {
                                case 'items':
                                    html += `<div class="search-result">
                                                <div class="row">
                                                    <div class="col-xs-2"><a href="${element.link}"><img width="50" src="${element.image}" alt="${element.label}"></a></div>
                                                    <div class="col-xs-10"><a href="${element.link}"><i class="icon icon-arrow-right"></i> ${element.label}</a><br><p><span class="text-muted">${element.identifier}</span></p></div>
                                                </div>
                                             </div>`
                                    break;
                                case 'categories':
                                    html += `<div class="search-result">
                                                <div class="row">
                                                    <div class="col-xs-12"><a href="${element.link}"><i class="icon icon-arrow-right"></i> ${element.label}</a></div>
                                                </div>
                                             </div>`
                                    break;
                                default:
                                    break;
                            }
                        });

                    });

                    $results.find('.js-search-result-list').html(html);
                }
            }
        }).catch((error) => {
        console.error(error)
    });
}

$(document).on('keyup', '.js-nav-search input', function (event) {
    event.preventDefault();

    nav_search($(this), $(this).closest('.js-nav-search'), $(this).closest('.js-nav-search').next());
});
$(document).on('submit', '.js-nav-search', function (event) {
    event.preventDefault();

    nav_search($(this).find('input'), $(this), $(this).next());
});
$(document).on('click', '.js-nav-search button', function (event) {
    event.preventDefault();

    nav_search($(this).closest('.js-nav-search').find('input'), $(this).closest('.js-nav-search'), $(this).closest('.js-nav-search').next());
});
$(document).on('click', '.js-close-search', function () {
    $('.js-nav-search-results').removeClass('active');
    $('.js-nav-search input').val('');
});
// endregion

// region Query Log Messages
$(document).ready(function () {
    let $messageBtn = $('.js-add-query-message');

    if ($messageBtn.length === 1) {
        $(document).on('click', '.js-add-query-message', function (event) {
            event.preventDefault();

            if (typeof cancelToken !== typeof undefined) {
                cancelToken.cancel("Operation canceled due to new request.");
            }

            cancelToken = axios.CancelToken.source();

            let $form = $(this).closest('form');

            let formData = new FormData($form[0]);

            $('.form-group').removeClass('has-error');
            $('.js-error-block').remove();

            axios({
                method: 'post',
                url: $form.attr('action'),
                data: formData,
                responseType: 'json',
                cancelToken: cancelToken.token,
            }).then((response) => {
                if (response.data.success) {
                    modalHandleResponse(response.data);
                }

                modalHandleMessage(response);

                $chatArea.scrollTop($chatArea.prop('scrollHeight'));

                if (grecaptcha !== undefined) {
                    try {
                        grecaptcha.reset();
                    } catch (error) {

                    }
                }
                $form[0].reset();
            }).catch((error) => {
                modalHandleValidation(error);

                if (grecaptcha !== undefined) {
                    try {
                        grecaptcha.reset();
                    } catch (error) {

                    }
                }
            });
        });
    }
});
// endregion

$('input:checkbox').on('keypress', function (event) {
    if (event.which === 13) {
        $(this).prop('checked', !$(this).prop('checked'));
        return false;
    }
});
